import { I18n } from 'react-redux-i18n';
import { enumPermissions } from '../data/permissions';

export const setInitialCheckboxsStatesAndValues = async (permissions, inputsStateDisabled) => {
  if (!permissions[enumPermissions.PRICE]) {
    inputsStateDisabled[enumPermissions.PURCHASE_CREDIT] = true;
    inputsStateDisabled[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = true;
    inputsStateDisabled[enumPermissions.PURCHASE_DEBIT] = true;
    inputsStateDisabled[enumPermissions.PURCHASE_BANK_SLIP] = true;
    inputsStateDisabled[enumPermissions.CART_USERS] = true;

    permissions[enumPermissions.PURCHASE_CREDIT] = false;
    permissions[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = false;
    permissions[enumPermissions.PURCHASE_DEBIT] = false;
    permissions[enumPermissions.PURCHASE_BANK_SLIP] = false;
    permissions[enumPermissions.CART_USERS] = false;
    if (!permissions[enumPermissions.PURCHASE_BILLING]) {
      permissions[enumPermissions.PURCHASE] = false;
    }
  }

  if (!permissions[enumPermissions.CART]) {
    inputsStateDisabled[enumPermissions.CART_USERS] = true;
    inputsStateDisabled[enumPermissions.PURCHASE_CREDIT] = true;
    inputsStateDisabled[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = true;
    inputsStateDisabled[enumPermissions.PURCHASE_DEBIT] = true;
    inputsStateDisabled[enumPermissions.PURCHASE_BANK_SLIP] = true;
    inputsStateDisabled[enumPermissions.PURCHASE_BILLING] = true;
    inputsStateDisabled[enumPermissions.PRICE] = true;

    permissions[enumPermissions.CART_USERS] = false;
    permissions[enumPermissions.PURCHASE_CREDIT] = false;
    permissions[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = false;
    permissions[enumPermissions.PURCHASE_DEBIT] = false;
    permissions[enumPermissions.PURCHASE_BANK_SLIP] = false;
    permissions[enumPermissions.PURCHASE_BILLING] = false;
    permissions[enumPermissions.PRICE] = false;
    permissions[enumPermissions.PURCHASE] = false;
  }

  if (inputsStateDisabled[enumPermissions.CART_USERS]) {
    permissions[enumPermissions.FIRST_APPROVED] = true;
    permissions[enumPermissions.SECOND_APPROVED] = true;
    inputsStateDisabled[enumPermissions.FIRST_APPROVED] = false;
    inputsStateDisabled[enumPermissions.SECOND_APPROVED] = false;
  } else {
    permissions[enumPermissions.FIRST_APPROVED] = false;
    permissions[enumPermissions.SECOND_APPROVED] = false;
    inputsStateDisabled[enumPermissions.FIRST_APPROVED] = true;
    inputsStateDisabled[enumPermissions.SECOND_APPROVED] = true;
  }

  if (permissions[enumPermissions.PURCHASE_CREDIT]
      || permissions[enumPermissions.PURCHASE_DEBIT]
      || permissions[enumPermissions.PURCHASE_BANK_SLIP]
      || permissions[enumPermissions.PURCHASE_BILLING]
      || permissions[enumPermissions.PURCHASE_PAYMENT_GATEWAY]) {
    permissions[enumPermissions.PURCHASE] = true;
  } else permissions[enumPermissions.PURCHASE] = false;

  return { inputsStateDisabled, permissions };
};

export const setCheckboxLabels = (inputsLabel) => {
  inputsLabel[enumPermissions.PURCHASE_CREDIT] = I18n.t('permissionLabel1');
  inputsLabel[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = I18n.t('permissionLabel1');
  inputsLabel[enumPermissions.PURCHASE_DEBIT] = I18n.t('permissionLabel1');
  inputsLabel[enumPermissions.PURCHASE_BANK_SLIP] = I18n.t('permissionLabel1');

  inputsLabel[enumPermissions.PRICE] = I18n.t('permissionLabel2');
  inputsLabel[enumPermissions.CART_USERS] = I18n.t('permissionLabel3');
  inputsLabel[enumPermissions.PURCHASE_BILLING] = I18n.t('permissionLabel2');
  inputsLabel[enumPermissions.ALLOW_MIXED_PURCHASE] = I18n.t('labelAllowMixedPurchase');

  return inputsLabel;
};

export const validateCheckboxPermissions = (enable, id, permissions, inputsStateDisabled) => {
  permissions[id] = enable;

  // Não permite selecionar CRED, DEB e BOLETO se VER PREÇO == desabilitado
  if (id === enumPermissions.PRICE) {
    if (!enable) {
      // Deixa input disabled como true e false nas permissões
      inputsStateDisabled[enumPermissions.PURCHASE_DEBIT] = true;
      inputsStateDisabled[enumPermissions.PURCHASE_CREDIT] = true;
      inputsStateDisabled[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = true;
      inputsStateDisabled[enumPermissions.PURCHASE_BANK_SLIP] = true;

      permissions[enumPermissions.PURCHASE_DEBIT] = false;
      permissions[enumPermissions.PURCHASE_CREDIT] = false;
      permissions[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = false;
      permissions[enumPermissions.PURCHASE_BANK_SLIP] = false;

      if (!permissions[enumPermissions.PURCHASE_BILLING]) {
        inputsStateDisabled[enumPermissions.CART_USERS] = true;
        permissions[enumPermissions.CART_USERS] = false;
      }
    } else {
      inputsStateDisabled[enumPermissions.PURCHASE_DEBIT] = false;
      inputsStateDisabled[enumPermissions.PURCHASE_CREDIT] = false;
      inputsStateDisabled[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = false;
      inputsStateDisabled[enumPermissions.PURCHASE_BANK_SLIP] = false;

      if (permissions[enumPermissions.PURCHASE_CREDIT]
          || permissions[enumPermissions.PURCHASE_DEBIT]
          || permissions[enumPermissions.PURCHASE_BANK_SLIP]
          || permissions[enumPermissions.PURCHASE_PAYMENT_GATEWAY]
      ) {
        inputsStateDisabled[enumPermissions.CART_USERS] = false;
      }
    }
  }

  if (id === enumPermissions.CART) {
    // VER PAINEL deve ter o mesmo valor que ACESSO AO CARRINHO
    permissions[enumPermissions.PANEL] = permissions[id];
    // SE !(ACESSO AO CARRINHO) NÃO PODE APROVAR CARRINHO E
    // TODOS METODOS DE PAGAMENTO DESABILITADOS E !VISUALIZAR PRECO
    if (enable) {
      if (!permissions[enumPermissions.PRICE]) {
        inputsStateDisabled[enumPermissions.PURCHASE_DEBIT] = true;
        inputsStateDisabled[enumPermissions.PURCHASE_CREDIT] = true;
        inputsStateDisabled[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = true;
        inputsStateDisabled[enumPermissions.PURCHASE_BANK_SLIP] = true;
      }

      inputsStateDisabled[enumPermissions.PRICE] = false;
      inputsStateDisabled[enumPermissions.PURCHASE_BILLING] = false;
    } else {
      inputsStateDisabled[enumPermissions.CART_USERS] = true;
      inputsStateDisabled[enumPermissions.PRICE] = true;
      inputsStateDisabled[enumPermissions.PURCHASE_DEBIT] = true;
      inputsStateDisabled[enumPermissions.PURCHASE_CREDIT] = true;
      inputsStateDisabled[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = true;
      inputsStateDisabled[enumPermissions.PURCHASE_BANK_SLIP] = true;
      inputsStateDisabled[enumPermissions.PURCHASE_BILLING] = true;

      permissions[enumPermissions.CART_USERS] = false;
      permissions[enumPermissions.PRICE] = false;
      permissions[enumPermissions.PURCHASE_DEBIT] = false;
      permissions[enumPermissions.PURCHASE_CREDIT] = false;
      permissions[enumPermissions.PURCHASE_PAYMENT_GATEWAY] = false;
      permissions[enumPermissions.PURCHASE_BANK_SLIP] = false;
      permissions[enumPermissions.PURCHASE_BILLING] = false;
      permissions[enumPermissions.PURCHASE] = false;
    }
  }

  if (id === enumPermissions.PURCHASE_CREDIT
      || id === enumPermissions.PURCHASE_DEBIT
      || id === enumPermissions.PURCHASE_BANK_SLIP
      || id === enumPermissions.PURCHASE_BILLING
      || id === enumPermissions.PURCHASE_PAYMENT_GATEWAY) {
    if (enable) {
      if (permissions[enumPermissions.PRICE]) {
        inputsStateDisabled[enumPermissions.CART_USERS] = false;
      }
      if ((id === enumPermissions.PURCHASE_BILLING) && permissions[enumPermissions.CART]) {
        inputsStateDisabled[enumPermissions.CART_USERS] = false;
      }
      permissions[enumPermissions.PURCHASE] = true;
    } else if (!permissions[enumPermissions.PURCHASE_CREDIT]
          && !permissions[enumPermissions.PURCHASE_DEBIT]
          && !permissions[enumPermissions.PURCHASE_BILLING]
          && !permissions[enumPermissions.PURCHASE_BANK_SLIP]) {
      inputsStateDisabled[enumPermissions.CART_USERS] = true;
      permissions[enumPermissions.CART_USERS] = false;
      permissions[enumPermissions.PURCHASE] = false;
    }
  }

  if (inputsStateDisabled[enumPermissions.CART_USERS]) {
    permissions[enumPermissions.FIRST_APPROVED] = true;
    permissions[enumPermissions.SECOND_APPROVED] = true;
    inputsStateDisabled[enumPermissions.FIRST_APPROVED] = false;
    inputsStateDisabled[enumPermissions.SECOND_APPROVED] = false;
  } else {
    permissions[enumPermissions.FIRST_APPROVED] = false;
    permissions[enumPermissions.SECOND_APPROVED] = false;
    inputsStateDisabled[enumPermissions.FIRST_APPROVED] = true;
    inputsStateDisabled[enumPermissions.SECOND_APPROVED] = true;
  }

  return { permissions, inputsStateDisabled };
};
